/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://httitylrejgxtl5udp7vqre7j4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-rlekqv6m5ffxfa64kc4bdnivja",
    "aws_cognito_identity_pool_id": "us-west-2:86080b31-1175-4345-8ac4-7cf892f22d10",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_4PPowBirg",
    "aws_user_pools_web_client_id": "54a607g3b4e21co0ausspb6oi",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "webapp577ff601f92d42e6bfdc3a64d89eed3c64929-maintwo",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "geo": {
        "amazon_location_service": {
            "region": "us-west-2",
            "search_indices": {
                "items": [
                    "karrotGeoCoder-maintwo"
                ],
                "default": "karrotGeoCoder-maintwo"
            }
        }
    }
};


export default awsmobile;
